import React, { useState } from 'react';
import { Paper, createStyles, TextInput, PasswordInput, Image, Button, Title, rem, Center, Text } from '@mantine/core';
import BgLogin from '../../assets/bg-login.png';
import MainLogoFull from '../../assets/logos/logo-webike-full.svg';
import { useForm } from '@mantine/form';
import { login } from '../../services/api.service';
import { notifications } from '@mantine/notifications';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Custom styles
const useStyles = createStyles((theme) => ({
	wrapper: {
		minHeight: '100%',
		backgroundSize: 'cover',
		backgroundImage: `url(${BgLogin})`, //TODO full resolution "final" image
	},
	form: {
		borderRight: `${rem(1)} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3]}`,
		height: '100vh',
		maxWidth: rem(450),
	},
	title: {
		color: theme.colorScheme === 'dark' ? theme.white : theme.black,
	},
}));

const Login = () => {

	// State and hooks
	const { classes } = useStyles();
	const [isLoading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const form = useForm({
		initialValues: {
			email: '',
			password: '',
		},
		validate: {
			email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Correo electrónico inválido'),
		},
	});

	// Perform login
	const submitLogin = (values) => {

		// Toggle loader
		setLoading(true);

		// Login via API
		login({ email: values.email, password: values.password }, function (response) {

			// Set timer
			setTimeout(() => {

				// Save token in localStorage
				localStorage.setItem('webikecc_jwt', response.data.tokens.accessToken);

				// Save in model
				dispatch.authData.setState({
					isLoggedIn: true,
					userId: response.data.admin.id,
					email: response.data.admin.email,
					name: response.data.admin.name,
					token: response.data.tokens.accessToken
				});

			}, 1500);

		}, function (error) {

			// Remove preloader
			setLoading(false);

			// Conditions
			if (typeof(error.message) === 'string') {

				// Show error
				notifications.show({
					title: 'Error',
					message: error.message,
					color: 'red'
				});

			} else {

				// Show error(s)
				for (var i = 0; i < error.message.length; i++) {

					// Show
					notifications.show({
						title: 'Error',
						message: error.message[i],
						color: 'red'
					});

				}

			}

		});

	}

	return (
		<div className={classes.wrapper}>
			<Paper className={classes.form} radius={0} p={30} pt={60}>
				{/* Logo */}
				<Center>
					<Image
						src={MainLogoFull}
						alt="Logo WeBike"
						maw={200}
						mb={35}
					/>
				</Center>
				{/* Title */}
				<Title order={3} className={classes.title} ta="center" mt="md" mb={35}>
					¡Bienvenido de vuelta a WeBike!
				</Title>
				{/* Form */}
				<form onSubmit={form.onSubmit(submitLogin)}>
					<TextInput
						label="Correo electrónico"
						placeholder="nombre@webikecc.com"
						size="sm"
						required
						value={form.values.email}
						onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
						{...form.getInputProps('email')}
					/>
					<PasswordInput
						label="Contraseña"
						placeholder="Tu contraseña"
						mt="md"
						size="sm"
						required
						value={form.values.password}
						onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
						{...form.getInputProps('password')}
					/>
					<Button
						fullWidth
						mt="xl"
						size="sm"
						type="submit"
						loading={isLoading}
					>
						Iniciar Sesión
					</Button>
					{/* Forgot password */}
					<Text
						ta="right"
						mt="md"
						size="xs"
					>
						<Link to="/forgot-password">Olvidé mi contraseña</Link>
					</Text>
				</form>
			</Paper>
		</div>
	);

}

export default Login;
